import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';

import VHChromeFix from './lib/mobile-chrome-vh-fix';

ReactDOM.render((
  <BrowserRouter>
    <App />
  </BrowserRouter>
), document.getElementById('root'));

const vhOptions = [
  {
    selector: '.page-section',
    vh: 100
  },
  {
    selector: '.hero-section',
    vh: 100
  },
  {
    selector: '.project-section',
    vh: 100
  },
  {
    selector: '.small-section',
    vh: 33
  }
]

new VHChromeFix(vhOptions);

console.log('New and improved! Looking for the old site? Visit https://old.peterliu.io');



// WEBPACK FOOTER //
// ./src/index.js